import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { NgbActiveModal, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { ValidationMessageRowComponent } from "../../../../../../../common/validation/validation-message-row/validation-message-row.component";
import { ITplWarningText } from "../../tpl-omdestinera.models";

export interface ITplWarningModalAo {
    beteckning: string;
    namn: string;
    warnings: ITplWarningText[];
}
@Component({
    selector: "rask-tpl-warning-modal",
    templateUrl: "./tpl-warning-modal.component.html",
    styleUrls: ["./tpl-warning-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        ValidationMessageRowComponent,
        ButtonComponent,
        TranslatePipe
    ]
})
export class TplWarningModalComponent {
    readonly activeModal = inject(NgbActiveModal);

    arbetsorder: ITplWarningModalAo;

    static open(
        arbetsorder: ITplWarningModalAo,
        modalService: NgbModal,
        callBack: (result: any) => void = null) {
        const options = {
            keyboard: false,
            backdrop: "static",
            size: "m",
            centered: true
        } as NgbModalOptions;
        const modalRef = modalService.open(this, options);
        modalRef.componentInstance.arbetsorder = arbetsorder;

        if (callBack) {
            modalRef.result.then(r => callBack(r));
        } else {
            modalRef.result.then(r => modalRef.close(r));
        }
    }

    getHeader() {
        return `${this.arbetsorder.beteckning} ${this.arbetsorder.namn}`;
    }

    close() {
        this.activeModal.close();
    }

}
